

<!------------ START TEMPLATE ------------>
<template>
  <div id="data-list-list-view" class="data-list-container">
    <add-new-data-sidebar
      :isSidebarActive="addNewDataSidebar"
      @closeSidebar="addNewDataSidebar = false"
      :form="formSideBar"
      :title="titleSideBar"
      :dados="dadosSideBar"
      @concluido="concluido"
      :key="chave"
    />

    <vs-table
      noDataText="Nenhuma Tabela Encontrada"
      class="tablePrincipal"
      ref="table"
      multiple
      v-model="selected"
      pagination
      :max-items="itemsPerPage"
      :data="itens"
    >
      <div
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-between"
      >
        <div class="flex flex-wrap-reverse items-center">
          <!------------ START  MENU DE AÇÕES ------------>
          <vs-dropdown vs-trigger-click class="cursor-pointer mr-4 mb-4">
            <div
              class="
                p-4
                shadow-drop
                rounded-lg
                d-theme-dark-bg
                cursor-pointer
                flex
                items-center
                justify-center
                text-lg
                font-medium
                w-32
              "
            >
              <span class="mr-2">Ações</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu>
              <vs-dropdown-item
                @click="inativar"
                v-if="$can($actionsDefault.Inativar, subjectPermission)"
              >
                <span>Inativar</span>
              </vs-dropdown-item>

              <vs-dropdown-item
                @click="reativar"
                v-if="$can($actionsDefault.Inativar, subjectPermission)"
              >
                <span>Reativar</span>
              </vs-dropdown-item>
              
              <vs-dropdown-item @click="imprimir">
                <span>Imprimir</span>
              </vs-dropdown-item>
              <vs-dropdown-item
                v-if="$can($actionsDefault.Exportar, subjectPermission)"
              >
                <span>
                  <downloadexcel
                    :data="selected"
                    :fields="colunas"
                    name="tabelas.xls"
                    type="xls"
                    >Exportar</downloadexcel
                  >
                </span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
          <!------------ END MENU DE AÇÕES ------------>

          <vs-dropdown vs-trigger-click class="cursor-pointer mr-4 mb-4">
            <div
              class="
                p-4
                shadow-drop
                rounded-lg
                d-theme-dark-bg
                cursor-pointer
                flex
                items-center
                justify-center
                text-lg
                font-medium
                w-32
              "
            >
              <span class="mr-2">Status</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu>
              <vs-dropdown-item @click="filtrarStatus()">
                <span>Todos</span>
              </vs-dropdown-item>

              <vs-dropdown-item @click="filtrarStatus('ativo')">
                <span>Ativo</span>
              </vs-dropdown-item>

              <vs-dropdown-item @click="filtrarStatus('inativo')">
                <span>Inativo</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>

          <!------------ START ADD NOVO Tabela ------------>
          <div
            class="
              p-3
              mb-4
              mr-4
              rounded-lg
              cursor-pointer
              flex
              items-center
              justify-between
              text-lg
              font-medium
              text-base text-primary
              border border-solid border-primary
            "
            @click="openSideBar({})"
            v-if="$can($actionsDefault.Escrita, subjectPermission)"
          >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary"
              >Adicionar nova Tabela</span
            >
          </div>
          <div
            class="
              p-3
              mb-4
              mr-4
              rounded-lg
              cursor-pointer
              flex
              items-center
              justify-between
              text-lg
              font-medium
              text-base text-primary
              border border-solid border-primary
            "
            @click="openSideBar({ selected: selected })"
            v-if="$can($actionsDefault.Escrita, subjectPermission)"
          >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary"
              >Adicionar nova Tabela a partir de uma já existente</span
            >
          </div>
        </div>
        <!------------ END ADD NOVO Tabela ------------>

        <!------------ START ITENS POR PÁGINA ------------>
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
          <div
            class="
              p-4
              border border-solid
              d-theme-border-grey-light
              rounded-full
              d-theme-dark-bg
              cursor-pointer
              flex
              items-center
              justify-between
              font-medium
            "
          >
            <span class="mr-2"
              >{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
              {{
                itens.length - currentPage * itemsPerPage > 0
                  ? currentPage * itemsPerPage
                  : itens.length
              }}
              de {{ itens.length }}</span
            >
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPage = 5">
              <span>5</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 25">
              <span>25</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 50">
              <span>50</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>
      <!------------ END ITENS POR PÁGINA ------------>

      <!------------ START TITULO DA TABELA ------------>

      <template slot="thead">
        <vs-th sort-key="nomeTabela">Nome</vs-th>
        <vs-th sort-key="grupo">Grupo</vs-th>
        <vs-th sort-key="locais">Locais</vs-th>
        <vs-th sort-key="deletedAt">Status</vs-th>
        <vs-th>Ações</vs-th>
      </template>
      <!------------ END TITULO DA TABELA ------------>

      <!------------ START TABELA ------------>
      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <p class="product-category">{{ tr.nomeTabela }}</p>
            </vs-td>

            <vs-td>
              <p class="product-category">{{ tr.grupo }}</p>
            </vs-td>

            <vs-td>
              <p class="product-category">{{ tr.locais.length }}</p>
            </vs-td>

            <vs-td>
              <vs-chip
                :color="getStatusColor(tr.deletedAt)"
                class="product-order-status"
                >{{ getStatusString(tr.deletedAt) }}</vs-chip
              >
            </vs-td>
            <vs-td>
              <div style="width: 350px">
                <!--vs-button
                  radius
                  color="dark"
                  type="gradient"
                  icon-pack="feather"
                  icon="icon-search"
                  class="d-inline"
                  @click="opemModal(tr.idTabela)"
                ></vs-button-->
                <vs-button
                  radius
                  v-tooltip="'Editar'"
                  color="success"
                  type="gradient"
                  icon-pack="feather"
                  icon="icon-edit"
                  class="d-inline"
                  @click="openSideBar(tr)"
                  v-if="$can($actionsDefault.Escrita, subjectPermission)"
                ></vs-button>
                <router-link :to="`listTabelaEstadosCidades/${tr.idTabela}`">
                  <vs-button
                    radius
                    color="secondary"
                    v-tooltip="'Locais'"
                    type="gradient"
                    icon-pack="feather"
                    icon="icon-map-pin"
                    class="d-inline"
                    v-if="$can('Locais', subjectPermission)"
                  >
                  </vs-button>
                </router-link>
                <router-link :to="`listTabelaValores/${tr.idTabela}`">
                  <vs-button
                    radius
                    color="dark"
                    v-tooltip="'Valores'"
                    type="gradient"
                    icon-pack="feather"
                    icon="icon-dollar-sign"
                    class="d-inline"
                    v-if="$can('Valores', subjectPermission)"
                  >
                  </vs-button>
                </router-link>
              </div>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
    <!------------ END TABELA ------------>

    <!------------ START INFORMAÇÕES DO TABELA ------------>
    <ModalInfo
      :modalSelecionado="modalSelecionado"
      :popupActive="popupActive"
      :title="`Dados da ${entidade}`"
      @close="popupActive = false"
    ></ModalInfo>

    <!------------ END INFORMAÇÕES DO TABELA ------------>
  </div>
</template>
<!------------ START TEMPLATE ------------>


<!------------ START SCRIPT ------------>
<script>
import AddNewDataSidebar from "./../Includes/SideBar";
import service from "../../services";
import downloadexcel from "vue-json-excel";
import ModalInfo from "../../components/ModalInfo";

export default {
  components: {
    AddNewDataSidebar,
    downloadexcel,
    ModalInfo,
  },
  props: ["filtro", "realizaFiltro", "subjectPermission"],
  watch: {
    realizaFiltro: function (newValue, oldValue) {
      if (newValue == true) {
        var filtra = false;
        this.itens = this.tabelas;
        if (this.filtro.idGrupo)
          this.itens = this.itens.filter(
            (x) => x.idGrupo == this.filtro.idGrupo.id
          );

        if (this.filtro.nomeTabela != "")
          this.itens = this.itens.filter(
            (x) => x.nomeTabela == this.filtro.nomeTabela
          );

        if (this.filtro.estado != "")
          this.itens = this.itens.filter(
            (x) => x.estados.indexOf(this.filtro.estado.label) >= 0
          );

        if (this.filtro.cidade)
          this.itens = this.itens.filter(
            (x) => x.cidades.indexOf(this.filtro.cidade.label) >= 0
          );
        this.$emit("filtroOk", true);
      }
    },
  },
  data() {
    return {
      chave: 0,
      idEmpresa: null,
      dadosSideBar: {},
      controllerGeral: "Tabela",
      formSideBar: "Tabela",
      entidade: "Tabela",
      titleSideBar: "Adicionar Tabela",
      popupActive: false,
      modalSelecionado: [],
      selected: [],
      itens: [],
      tabelas: [],
      colunas: {},
      itemsPerPage: 10,
      isMounted: false,
      addNewDataSidebar: false,
      StatusSelect: null
    };
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
  },
  methods: {
    imprimir() {
      setTimeout(function () {
        window.print();
      }, 500);
    },
    inativar() {
      this.checkSelected();

      if (this.selected.length > 0) {
        this.$vs.loading();
        var ids = [];
        this.selected.forEach((element) => {
          ids.push(element.idTabela);
        });
        service
          .post(this.controllerGeral, "Inativar", { ids: ids })
          .then(() => {
            this.$vs.notify({
              position: "top-center",
              title: "Atenção",
              text: "Registro inativado(s) com sucesso",
              color: "success",
            });
            this.$vs.loading.close();
            this.buscaDados();
          })
          .catch((e) => {
            this.$vs.notify({
              position: "top-center",
              title: "Atenção",
              text: e,
              color: "danger",
            });
            this.$vs.loading.close();
          });
      } else {
        this.$vs.notify({
          position: "top-center",
          title: "Atenção",
          text: "Selecione pelo menos um registro",
          color: "danger",
        });
      }
    },
    reativar() {
      this.checkSelected();

      if (this.selected.length > 0) {
        this.$vs.loading();
        var ids = [];
        this.selected.forEach((element) => {
          ids.push(element.idTabela);
        });
        service
          .post(this.controllerGeral, "Reativar", { ids: ids })
          .then(() => {
            this.$vs.notify({
              position: "top-center",
              title: "Atenção",
              text: "Registro reativado(s) com sucesso",
              color: "success",
            });
            this.$vs.loading.close();
            this.buscaDados();
          })
          .catch((e) => {
            this.$vs.notify({
              position: "top-center",
              title: "Atenção",
              text: e,
              color: "danger",
            });
            this.$vs.loading.close();
          });
      } else {
        this.$vs.notify({
          position: "top-center",
          title: "Atenção",
          text: "Selecione pelo menos um registro",
          color: "danger",
        });
      }
    },
    buscaDados() {
      this.selected = [];
      this.$vs.loading();

      service
        .getAll(this.controllerGeral, {}, "list/idEmpresa=" + this.idEmpresa)
        .then((res) => {
          this.itens = [];
          this.tabelas = [];

          res.data.forEach((element) => {
            element.grupo = element.Tabelas_Grupo.nomeGrupo;
            delete element.Tabelas_Grupo;

            var arrAux = [];
            var arrCidades = [];
            var arrEstados = [];

            element.Tabelas_EstadosCidades.forEach((el) => {
              arrAux.push({
                estado: el.estado,
                cidade: el.cidade,
              });
              arrEstados.push(el.estado);
              if (el.cidade) arrCidades.push(el.cidade);
            });
            element.locais = arrAux;
            element.cidades = arrCidades;
            element.estados = arrEstados;
            delete element.Tabelas_EstadosCidades;
            this.itens.push(element);
            this.tabelas.push(element);
          });
          this.colunas = {};
          if (this.itens[0])
            Object.keys(this.itens[0]).forEach((element) => {
              if (
                element != "createdAt" &&
                element != "updatedAt" &&
                element != "deletedAt" &&
                element != "estados" &&
                element != "cidades" &&
                element.indexOf("id") != 0
              ) {
                this.colunas[element] = element;
              }
            });
          this.$vs.loading.close();
        })
        .catch((e) => {
          this.$vs.notify({
            position: "top-center",
            title: "Atenção",
            text: e,
            color: "danger",
          });
          this.$vs.loading.close();
        });
    },
    openSideBar(dados) {
      if (dados.idTabela == null) {
        this.titleSideBar = `Adicionar ${this.entidade} `;
      } else {
        this.titleSideBar = `Editar dados do ${this.entidade}`;
      }

      this.dadosSideBar = dados;
      this.addNewDataSidebar = true;
    },
    opemModal(cod) {
      this.modalSelecionado = [];
      this.popupActive = true;
      var item = this.itens.find((x) => x.idTabela == cod);
      Object.keys(item).forEach((element) => {
        if (
          element != "createdAt" &&
          element != "updatedAt" &&
          element != "deletedAt" &&
          element.indexOf("id") != 0
        )
          this.modalSelecionado.push({
            coluna: element,
            [element]: item[element],
          });
      });
    },
    concluido() {
      this.chave++;
      this.buscaDados();
    },
    getStatusColor(data) {
      if (data == null) return "success";
      return "danger";
    },
    getStatusString(data) {
      if (data == null) return "Ativo";
      return "Inativo";
    },
    filtrarStatus(status) {
      this.selected = [];
      if (!status) return this.itens = this.tabelas;

      this.itens = this.tabelas.filter(item =>
        status === 'ativo' ? !item.deletedAt : item.deletedAt);
    },
    checkSelected() {
      if ((this.selected === this.itens) && (this.selected.length > this.itemsPerPage)) {
        this.selected = [];
        for (let i = 0; i < this.itemsPerPage; i++) {
          this.selected.push(this.itens[i]);
        };
      };
    }
  },
  created() {
    this.buscaDados();
  },
  mounted() {
    this.isMounted = true;
  },
};
</script>
<!------------ END SCRIPT ------------>


<!------------ START STYLE ------------>
<style lang="scss">
@media print {
  #content-area {
    margin-left: 0px;
  }
  .navbar-sticky .router-view .router-content {
    margin-top: 0px;
  }
  .vs-content-sidebar,
  .con-pagination-table,
  #data-list-list-view .vs-con-table .vs-table--header,
  .the-footer,
  .vs-navbar {
    display: none !important;
  }
  body,
  .vs-con-table .vs-con-tbody {
    background-color: #ffffff;
  }
  .vx-card,
  #data-list-list-view .vs-con-table .vs-table tr {
    box-shadow: none !important;
  }
  .td-check {
    visibility: hidden;
  }
}

#data-list-list-view {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
.vs-button.includeIcon {
  float: left;
  margin-right: 5px;
}
</style>

<!------------ END STYLE ------------>
